import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const { customer } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (customer && customer !== false) {
      navigate("/account", { replace: true });
    }
  }, [customer, navigate]);

  const startGoogleAuth = () => {
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grain bg-cream text-forest flex flex-col">
      <header className="px-8 py-6 flex items-center justify-between">
        <Link to="/" className="tracking-widest text-sm font-semibold uppercase" data-testid="login-home-link">
          Prestige Wellness Co
        </Link>
        <Link to="/" className="text-xs uppercase tracking-widest text-forest/60 hover:text-forest">
          ← Back to store
        </Link>
      </header>

      <main className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-md">
          <div className="mb-10">
            <p className="text-xs uppercase tracking-[0.28em] text-forest/60 mb-3">Members</p>
            <h1 className="text-4xl sm:text-5xl leading-tight font-serif mb-4">
              Welcome back.
            </h1>
            <p className="text-forest/70">
              Sign in with Google to view your orders, manage your monthly subscriptions, and update your card.
            </p>
          </div>

          <button
            data-testid="google-signin-btn"
            onClick={startGoogleAuth}
            className="w-full flex items-center justify-center gap-3 px-6 py-4 rounded-full bg-forest text-cream hover:bg-forest/90 transition-all"
          >
            <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
              <path fill="#EA4335" d="M12 10.2v3.8h5.35c-.24 1.4-1.7 4.1-5.35 4.1-3.22 0-5.85-2.68-5.85-6s2.63-6 5.85-6c1.83 0 3.05.78 3.75 1.45l2.55-2.45C16.7 3.6 14.55 2.6 12 2.6 6.75 2.6 2.5 6.85 2.5 12s4.25 9.4 9.5 9.4c5.5 0 9.13-3.87 9.13-9.3 0-.62-.07-1.1-.16-1.55L12 10.2z" />
            </svg>
            <span className="text-sm uppercase tracking-widest">Continue with Google</span>
          </button>

          <p className="mt-8 text-xs text-forest/50 leading-relaxed">
            By continuing you agree to our terms. We only use your Google email to identify your orders and subscriptions.
          </p>
        </div>
      </main>
    </div>
  );
}
